import React, { PropsWithChildren } from 'react';
import { Breadcrumbs } from '@ygtechnologies/bygr-frontend-component-library';
import SimpleFormPage from '@/components/SimpleFormPage/SimpleFormPage';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { BreadcrumbsProjectLink } from '@/components/navigation';

interface ProjectInviteWrapperProps extends PropsWithChildren {
    projectName: string;
}

const ProjectInviteWrapper: React.FC<ProjectInviteWrapperProps> = ({ projectName, children }) => {
    return (
        <>
            <Breadcrumbs>
                <BreadcrumbsProjectLink to="/">{projectName}</BreadcrumbsProjectLink>

                <BreadcrumbsProjectLink to="/users">
                    <Trans>Users</Trans>
                </BreadcrumbsProjectLink>

                <Breadcrumbs.Item>
                    <Trans>Invite a user</Trans>
                </Breadcrumbs.Item>
            </Breadcrumbs>
            <SimpleFormPage header={t`Invite a user`}>{children}</SimpleFormPage>
        </>
    );
};

export default ProjectInviteWrapper;
